import { PublicSelection } from '../../../../tma/src/productEntry/PublicSelection';
import { OAuthLanding } from '../../../../tma/src/productEntry/EntryOAuth';
import { createBrowserWindow } from '../../../../tma/src/productEntry/oauth';
import { apiFetch } from '../api/client';
import { EntryContinuation, ProductEntryPage, SolutionsHome } from '../../../../tma/src/productEntry/ProductEntry';
const base = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '';
const publicText = async (path: string) => {
  const res = await fetch(`${base}${path}`,{credentials:'omit'});
  if(!res.ok)throw Error('demo_unavailable');return res.text();
};
export const Solutions = () => <SolutionsHome request={apiFetch} publicText={publicText}/>;
export const HomeSolutions = () => <SolutionsHome compact request={apiFetch} publicText={publicText}/>;
export const Solution = () => <ProductEntryPage request={apiFetch} publicText={publicText} origin="web" beginExternal={createBrowserWindow}/>;
export const ContinueEntry = () => <EntryContinuation request={apiFetch}/>;

export const OAuthReturn = () => <OAuthLanding request={apiFetch}/>;

const publicRequest = async <T,>(path:string,options?:RequestInit):Promise<T> => {
  const response=await fetch(`${base}${path}`,{...options,credentials:'omit',headers:{Accept:'application/json'}});
  if(!response.ok)throw Error('public_entry_unavailable');return response.json() as Promise<T>;
};
export const AnonymousEntry = ({search,onLogin}:{search:string;onLogin:()=>void}) => <PublicSelection search={search} request={publicRequest} publicText={publicText} onLogin={onLogin}/>;
